export const buildTime = '2026-09-12 19:49:55 UTC';
